<template>
    <div>
        <form novalidate class="md-layout" @submit.prevent="validateUser">
            <md-card class="md-layout-item md-size-50 md-small-size-100">
                <md-card-content>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">

                            <md-field :class="getValidationClass('firstName')">
                                <label for="first-name">Vorname</label>
                                <md-input name="first-name" id="first-name"
                                          v-model="form.firstName" :disabled="sending"/>
                                <span class="md-error"
                                      v-if="!$v.form.firstName.required">Vorname ist notwendig</span>
                                <span class="md-error"
                                      v-else-if="!$v.form.firstName.minlength">Ung�ltiger Vorname</span>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('lastName')">
                                <label for="last-name">Name</label>
                                <md-input name="last-name" id="last-name"
                                          v-model="form.lastName" :disabled="sending"/>
                                <span class="md-error" v-if="!$v.form.lastName.required">Name ist notwendig</span>
                                <span class="md-error" v-else-if="!$v.form.lastName.minlength">Ung�ltiger Name</span>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('adresse')">
                                <label for="adresse">Adresse</label>
                                <md-input name="adresse" id="adresse" v-model="form.adresse"
                                          :disabled="sending"/>
                                <span class="md-error" v-if="!$v.form.adresse.required">Adresse ist notwendig</span>
                                <span class="md-error" v-else-if="!$v.form.adresse.minlength">Ung�ltige Adresse</span>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-layout-item md-size-35  margin--bottom-0">
                            <md-field :class="getValidationClass('zipCode')" :md-counter="false">
                                <label for="zip-code">PLZ</label>
                                <span class="zip-code-prefix">CH-</span>
                                <md-input type="text" name="zip-code" id="zip-code" maxlength="4" v-on:keypress="isNumberKey" v-model="form.zipCode"
                                          :disabled="sending"/>

                            </md-field>
                        </div>
                        <div class="md-layout-item md-layout-item md-size-65 margin--bottom-0">
                            <md-field :class="getValidationClass('city')">
                                <label for="city">Ort</label>
                                <md-input name="city" id="city" v-model="form.city"
                                          :disabled="sending"/>

                            </md-field>
                        </div>
                        <div class="md-layout-item md-small-size-100 custom-row">
                            <md-field :class="getValidationClass('zipCode')">
                                <span class="md-error" v-if="!$v.form.zipCode.required">PLZ ist notwendig</span>
                                <span class="md-error" v-else-if="!$v.form.zipCode.validateZipCode">Bitte geben Sie eine g�ltige Postleitzahl ein, z.B. 3038.</span>
                            </md-field>
                            <md-field :class="getValidationClass('city')">
                                <span class="md-error" v-if="!$v.form.city.required">Ort ist notwendig</span>
                                <span class="md-error" v-else-if="!$v.form.city.minlength">Ung�ltige Ort</span>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-small-size-100 email-field">
                            <md-field :class="getValidationClass('email')">
                                <label for="email">E-Mail</label>
                                <md-input type="email" name="email" id="email"  v-model="form.email"
                                          :disabled="sending"/>
                                <span class="md-error" v-if="!$v.form.email.required">E-Mail ist notwendig</span>
                                <span class="md-error" v-else-if="!$v.form.email.email">Ung�ltige E-Mail</span>
                            </md-field>
                        </div>
                    </div>

                </md-card-content>

                <md-progress-spinner md-mode="indeterminate" v-if="sending"/>

                <md-card-actions>
                    <button type="submit" class="md-primary button margin margin--bottom-30" :disabled="sending">{{currentData.buttonCopy}}</button>
                </md-card-actions>
            </md-card>
        </form>
    </div>
</template>
<style lang="scss">
    @import "../../sass/layout";
</style>

<script>
    import Vue from 'vue';
    import {validationMixin} from 'vuelidate';

    Vue.use(VueMaterial);
    import VueMaterial from 'vue-material';
    import {
        required,
        email,
        minLength,
        maxLength
    } from 'vuelidate/lib/validators'

    import {withParams} from 'vuelidate/lib'
    import data from '../assets/data/data'

    import axios from 'axios';

    import config from '../assets/data/config.json';

    const validateZipCode = withParams({type: 'validateZipCode'}, value => {

        return /^\d{4}$/.test(value);

    });

    export default {

        name: 'FormValidation',
        mixins: [validationMixin],
        data: () => ({
            data: data,
            localStorage: localStorage.getItem('formSubmitted'),
            form: {
                firstName: null,
                lastName: null,
                zipCode: null,
                adresse: null,
                city: null,
                email: null,
            },
            sending: false
        }),
        mounted: function(){

        },
        computed: {
            currentData: function () {
                return this.data.activities[this.$route.params.id].form;
            }
        },
        validations: {

            form: {
                firstName: {
                    required,
                    minLength: minLength(3)
                },
                lastName: {
                    required,
                    minLength: minLength(3)
                },
                zipCode: {
                    required,
                    validateZipCode
                },

                adresse: {
                    required,
                    minLength: minLength(3)
                },
                city: {
                    required,
                    minLength: minLength(3)
                },
                email: {
                    required,
                    email
                }
            }
        },
        methods: {
            isNumberKey(evt) {
                var ch = String.fromCharCode(evt.which);

                if(!(/[0-9]/.test(ch))){
                    evt.preventDefault();
                }
            },
            getValidationClass(fieldName) {
                const field = this.$v.form[fieldName]

                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty
                    }
                }
            },
            clearForm() {
                this.$v.$reset()
                this.form.firstName = null
                this.form.lastName = null
                this.form.email = null
                this.form.zipCode = null
                this.form.adresse = null
                this.form.city = null
            },

            saveFormData() {
                this.sending = true

                const formData = {
                    "activityType": this.$route.params.id,
                    "form": {
                        "firstName": this.form.firstName,
                        "lastName": this.form.lastName,
                        "email": this.form.email,
                        "zipCode": this.form.zipCode,
                        "adresse": this.form.adresse,
                        "city": this.form.city
                    }
                };
                axios.post(config.endpoint.form, formData).then(response => {

                    this.sending = false;
                    this.clearForm();

                    localStorage.setItem("formSubmitted", true);

                    this.$router.push({ path: `/activityType/${this.$route.params.id}/thank-you` })

                }, (errResponse, second) => {

                    this.sending = false;

                    if(errResponse.response.data.errors.emailAlreadyUsed){

                        localStorage.setItem("formSubmitted", true);
                        this.$emit('onValidation');

                    }

                }).catch(function (e) {

                    console.log('catch e', e);

                });

            },
            validateUser() {
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    this.saveFormData()
                }
            }
        }
    }
</script>
